import axios from "axios"

const local = false
const url = local ? "http://localhost:3847/api" : "https://assets.benjamin-widawski.com/api"

const api = {
    check: async() => {
        return await axios.get(url)
    },
    getAllPlugins: async(type) => {
        return await axios.get(url + "/plugins" + (type === '' ? "" : "?type=" + type))
    },
    getPluginById: async(id) => {
        return await axios.get(url + "/plugins/" + id)
    },
    addPlugin: async(plugin) => {
        return await axios.post(url + "/plugins", plugin)
    },
    editPlugin: async(id, plugin) => {
        return await axios.post(url + "/plugins/" + id, plugin)
    },
}

export default api
